<template>
  <div class="addActivities">
    <div class="main">
      <el-form ref="forms" :model="form" label-width="160px" :rules="rules">
        <el-form-item label="活动名称" prop="activityName">
          <el-input
            v-model="form.activityName"
            placeholder="活动名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动时间" prop="activityTime">
          <el-date-picker
            format="yyyy-MM-dd HH:mm"
            v-model="form.activityTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="活动介绍" prop="content">
          <el-input v-model="form.content" placeholder="活动介绍"></el-input>
        </el-form-item>

        <el-form-item label="活动图片(最多4张)" prop="activityUrl">
          <el-upload
            :action="imgURL"
            list-type="picture-card"
            :on-success="successUrl"
            :before-upload="beforeAvatarUpload"
            :on-remove="handleRemove"
            :limit="4"
            :file-list="activityUrl"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn">
      <el-button type="primary" @click="addSubmit('forms')">提交</el-button>
      <!-- <el-button type="primary" @click="goBack">返回</el-button> -->
    </div>
  </div>
</template>

<script>
import { IP, updateActivity, activityDetail } from "@/api/api";
import moment from "moment";
import reg from "@/utils/reg.js";

export default {
  data() {
    return {
      // 图片上传地址
      imgURL: IP + "/images/uploadImage",

      form: {
        barId: "",
        activityTime: "",
        activityName: "", //活动名称
        content: "", //活动介绍
        activityUrl: [], //图片列表
        startTime: "",
        endTime: "",
      },
      activityUrl: [],
      rules: {
        //验证规则
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        activityTime: [
          { required: true, message: "请选择活动时间", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入活动介绍", trigger: "blur" },
        ],
        activityUrl: [
          { required: true, message: "请输入活动图片", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    // 活动详情
    async getInfo() {
      let res = await activityDetail({ id: this.$route.query.activityId });
      console.log(res);
      if (res.code == 200) {
        res.data.activityUrl.map((item) => {
          this.activityUrl.push({
            url: item,
          });
        });
        res.data.activityTime = ["", ""];
        res.data.activityTime[0] = new Date(res.data.startTime);
        res.data.activityTime[1] = new Date(res.data.endTime);

        // this.form.activityTime=new Date(this.form.activityTime)
        this.form = res.data;
      }
    },
    //   提交
    addSubmit: reg._debounce(function (formName) {
      (this.form.startTime = moment(this.form.activityTime[0]).format(
        "YYYY-MM-DD HH:mm"
      )),
        (this.form.endTime = moment(this.form.activityTime[1]).format(
          "YYYY-MM-DD HH:mm"
        ));
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let { code, msg } = await updateActivity({
            id: this.$route.query.activityId,
            barId: this.form.barId,
            activityName: this.form.activityName,
            content: this.form.content,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            activityUrl: this.form.activityUrl,
          });

          if (code == 200) {
            this.$message({
              type: "success",
              message: "修改成功",
            });
            setTimeout(() => {
              this.$router.push("/activityList?barId=" + this.form.barId);
            }, 100);
          }
        }
      });
    }, 200),
    querys() {
      if (this.activityTime == null) {
        (this.startTime = ""), (this.endTime = "");
      }
    },
    // 活动图片上传
    successUrl(e) {
      console.log(e);
      this.form.activityUrl.push(e);
    },
    // 活动图片删除
    handleRemove(e) {
      console.log(e);
      this.form.activityUrl.forEach((item, i) => {
        if (item == e.response || e.url == item) {
          this.form.activityUrl.splice(i, 1);
        }
      });
    },
    //  图片上传
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif";
      if (!isJPG) {
        this.$message.error("图片只能是 JPG,PNG,JPEG,GIF!");
      }
      return isJPG;
    },
  },
};
</script>

<style lang="less" scoped>
.addActivities {
  background: #fff;
  height: 100%;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  overflow-y: scroll;
  .mian {
    width: 70%;
  }
}
.btn {
  padding: 0 160px;
}
</style>